import { GET_REPORT_REQUEST, GET_REPORT_SUCCESS, GET_REPORT_ERROR } from './reportActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  message: '',
};

export default function reportReducer(state = initialState, action) {
  const { type, isLoading, message } = action;

  switch (type) {
    case GET_REPORT_REQUEST:
      return { ...state, isLoading };
    case GET_REPORT_SUCCESS:
      return { ...state, isLoading };
    case GET_REPORT_ERROR:
      return { ...state, isLoading, message };
    default: {
      return state;
    }
  }
}
